import React from "react";
import { Col } from "reactstrap";
import { GetLanguageString, BouncingLoader } from "../helper/Components";

const formatRs = (value) =>
  `Rs ${new Intl.NumberFormat().format(Number(value) || 0)}`;

export const CashAccountBalanceCard = ({
  balance,
  loading = false,
  colProps = { xs: "12", md: "6", className: "mb-3" },
  labelKey = "cash_account_balance",
  badgeText = "Account Balance",
}) => {
  return (
    <Col {...colProps}>
      <div
        style={{
          background: "linear-gradient(135deg, #486A84 0%, #39576B 45%, #2D4455 100%)",
          color: "#ffffff",
          padding: "14px 18px",
          borderRadius: "14px",
          boxShadow: "0 8px 24px rgba(22, 55, 60, 0.14)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          minHeight: "95px",
          transition: "all 0.25s ease-in-out",
          cursor: "default",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-2px)";
          e.currentTarget.style.boxShadow = "0 12px 28px rgba(22, 55, 60, 0.2)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 8px 24px rgba(22, 55, 60, 0.14)";
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.9 }}>
              <path d="M20 12V8H6a2 2 0 0 1-2-2c0-1.1.9-2 2-2h12v4" />
              <path d="M4 6v12a2 2 0 0 0 2 2h14v-4" />
              <path d="M18 12a2 2 0 0 0 0 4h4v-4z" />
            </svg>
            <span style={{ fontSize: "13px", fontWeight: "700", letterSpacing: "0.2px", color: "#ffffff" }}>
              <GetLanguageString props={labelKey} />
            </span>
          </div>
          <span
            style={{
              background: "rgba(255, 255, 255, 0.14)",
              border: "1px solid rgba(255, 255, 255, 0.18)",
              backdropFilter: "blur(10px)",
              WebkitBackdropFilter: "blur(10px)",
              color: "#ffffff",
              borderRadius: "999px",
              fontSize: "10px",
              fontWeight: "600",
              padding: "2px 10px",
            }}
          >
            {badgeText}
          </span>
        </div>
        <div style={{ fontSize: "22px", fontWeight: "800", marginTop: "6px", letterSpacing: "-0.4px", color: "#ffffff" }}>
          {loading ? <BouncingLoader /> : formatRs(balance)}
        </div>
      </div>
    </Col>
  );
};

export const AmanatAccountBalanceCard = ({
  balance,
  loading = false,
  colProps = { xs: "12", md: "6", className: "mb-3" },
}) => {
  return (
    <Col {...colProps}>
      <div
        style={{
          background: "linear-gradient(135deg, #35A08E 0%, #237A6E 45%, #1B6258 100%)",
          color: "#ffffff",
          padding: "14px 18px",
          borderRadius: "14px",
          boxShadow: "0 8px 24px rgba(22, 55, 60, 0.14)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          minHeight: "95px",
          transition: "all 0.25s ease-in-out",
          cursor: "default",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-2px)";
          e.currentTarget.style.boxShadow = "0 12px 28px rgba(22, 55, 60, 0.2)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 8px 24px rgba(22, 55, 60, 0.14)";
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.9 }}>
              <path d="M3 21h18M3 10h18M5 6l7-3 7 3M4 10v11M20 10v11M8 14v3M12 14v3M16 14v3" />
            </svg>
            <span style={{ fontSize: "13px", fontWeight: "700", letterSpacing: "0.2px", color: "#ffffff" }}>
              <GetLanguageString props="transactions_amanat_account_balance" />
            </span>
          </div>
          <span
            style={{
              background: "rgba(255, 255, 255, 0.14)",
              border: "1px solid rgba(255, 255, 255, 0.18)",
              backdropFilter: "blur(10px)",
              WebkitBackdropFilter: "blur(10px)",
              color: "#ffffff",
              borderRadius: "999px",
              fontSize: "10px",
              fontWeight: "600",
              padding: "2px 10px",
            }}
          >
            Account Balance
          </span>
        </div>
        <div style={{ fontSize: "22px", fontWeight: "800", marginTop: "6px", letterSpacing: "-0.4px", color: "#ffffff" }}>
          {loading ? <BouncingLoader /> : formatRs(balance)}
        </div>
      </div>
    </Col>
  );
};

export const MetricCard = ({
  labelKey,
  label,
  value,
  badgeText,
  icon,
  tone = "slate", // "slate" | "emerald"
  format = "currency", // "currency" | "integer" | "days"
  loading = false,
  colProps = { xs: "12", md: "6", className: "mb-3" },
}) => {
  const isEmerald = tone === "emerald";
  const bg = isEmerald
    ? "linear-gradient(135deg, #EBF7F4 0%, #DCF1EB 100%)"
    : "linear-gradient(135deg, #EEF4F8 0%, #E2EDF4 100%)";
  const border = isEmerald
    ? "1px solid rgba(53, 160, 142, 0.25)"
    : "1px solid rgba(72, 106, 132, 0.22)";
  const shadow = isEmerald
    ? "0 6px 20px rgba(35, 122, 110, 0.08)"
    : "0 6px 20px rgba(72, 106, 132, 0.08)";
  const hoverShadow = isEmerald
    ? "0 10px 24px rgba(35, 122, 110, 0.14)"
    : "0 10px 24px rgba(72, 106, 132, 0.14)";
  const textColor = isEmerald ? "#1B6258" : "#2D4455";
  const valueColor = isEmerald ? "#144D44" : "#1F384C";
  const badgeBg = isEmerald ? "rgba(53, 160, 142, 0.14)" : "rgba(72, 106, 132, 0.12)";
  const badgeBorder = isEmerald ? "1px solid rgba(53, 160, 142, 0.22)" : "1px solid rgba(72, 106, 132, 0.18)";

  return (
    <Col {...colProps}>
      <div
        style={{
          background: bg,
          border,
          color: textColor,
          padding: "14px 18px",
          borderRadius: "14px",
          boxShadow: shadow,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          minHeight: "95px",
          transition: "all 0.25s ease-in-out",
          cursor: "default",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-2px)";
          e.currentTarget.style.boxShadow = hoverShadow;
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = shadow;
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            {icon}
            <span style={{ fontSize: "13px", fontWeight: "700", letterSpacing: "0.2px", color: textColor }}>
              {labelKey ? <GetLanguageString props={labelKey} /> : label}
            </span>
          </div>
          {badgeText && (
            <span
              style={{
                background: badgeBg,
                border: badgeBorder,
                color: textColor,
                borderRadius: "999px",
                fontSize: "10px",
                fontWeight: "600",
                padding: "2px 10px",
              }}
            >
              {badgeText}
            </span>
          )}
        </div>
        <div style={{ fontSize: "22px", fontWeight: "800", marginTop: "6px", letterSpacing: "-0.4px", color: valueColor }}>
          {loading ? (
            <BouncingLoader />
          ) : format === "integer" ? (
            new Intl.NumberFormat().format(Number(value) || 0)
          ) : format === "days" ? (
            `${new Intl.NumberFormat().format(Number(value) || 0)}`
          ) : (
            formatRs(value)
          )}
        </div>
      </div>
    </Col>
  );
};
